(function () {
  'use strict';
  if (window.__lionLuxuryMeasurementV2) return;
  window.__lionLuxuryMeasurementV2 = true;
  const testMode = new URLSearchParams(window.location.search).get('ll_tracking_test') === '20261005';
  const previewMode = Boolean(window.Shopify && window.Shopify.designMode) || new URLSearchParams(window.location.search).has('preview_theme_id');
  let recentTest = false;
  try {
    if (testMode) window.sessionStorage.setItem('lion_measurement_qa_until', String(Date.now() + 2 * 60 * 60 * 1000));
    recentTest = Number(window.sessionStorage.getItem('lion_measurement_qa_until')) > Date.now();
  } catch (_) {}
  const internalTest = testMode || previewMode || recentTest;
  const whatsappHosts = new Set(['wa.me', 'api.whatsapp.com', 'web.whatsapp.com', 'whatsapp.com', 'wa.link']);
  const readArticles = new WeakSet();
  let sequence = 0;
  let framePending = false;

  function safeUrl(value) {
    const url = new URL(value, window.location.origin);
    const safe = new URL(url.origin + url.pathname);
    for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'll_tracking_test']) {
      if (url.searchParams.has(key)) safe.searchParams.set(key, url.searchParams.get(key));
    }
    return safe.href;
  }
  function context() {
    const path = window.location.pathname;
    return {
      button_location: path === '/' ? 'home' : path === '/cart' ? 'cart' : path.startsWith('/blogs/') ? 'blog' : path.includes('/products/') ? 'product' : path.startsWith('/collections/') ? 'collection' : 'page',
      page_location: safeUrl(window.location.href),
      page_path: path,
      page_title: document.title,
      is_internal_test: internalTest,
      measurement_version: '2026-10-14'
    };
  }
  function note(name, outcome) {
    if (!testMode || !document.body) return;
    let panel = document.getElementById('lion-measurement-test');
    if (!panel) {
      panel = document.createElement('aside');
      panel.id = 'lion-measurement-test';
      panel.setAttribute('aria-label', 'Medición de prueba');
      panel.style.cssText = 'position:fixed;bottom:16px;left:16px;z-index:2147483646;max-width:360px;background:#fff;color:#172c27;border:1px solid #275542;padding:12px;font:12px/1.5 Arial;box-shadow:0 3px 14px #0002;pointer-events:none';
      const heading = document.createElement('strong');
      heading.textContent = 'Prueba de medición Lion Luxury';
      panel.appendChild(heading);
      document.body.appendChild(panel);
    }
    const item = document.createElement('div');
    item.textContent = name.replace(/^lion_/, '') + ' · ' + outcome;
    panel.appendChild(item);
    while (panel.children.length > 7) panel.removeChild(panel.children[1]);
  }
  function publish(name, details) {
    const analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return false;
    const payload = Object.assign(context(), details || {}, { action_id: 'll-' + Date.now().toString(36) + '-' + (++sequence) });
    try {
      const result = analytics.publish(name, payload);
      note(name, 'publicado a Shopify');
      if (result && typeof result.catch === 'function') result.catch(function () { note(name, 'no entregado'); });
      return true;
    } catch (_) {
      note(name, 'no entregado');
      return false;
    }
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (!link) return;
    const path = window.location.pathname;
    let destination;
    try { destination = new URL(link.href, window.location.origin); } catch (_) { return; }
    if (whatsappHosts.has(destination.hostname.toLowerCase())) {
      publish('lion_whatsapp_click', { destination_type: 'whatsapp', link_text: (link.textContent || '').trim().slice(0, 100) });
      return;
    }
    const videoMatch = /^\/pages\/(video-[a-z0-9-]+)\/?$/.exec(path);
    if (videoMatch && document.querySelector('.llv134-player')) {
      if (destination.origin !== window.location.origin) return;
      const destinationType = destination.pathname.includes('/products/') ? 'product' : destination.pathname.startsWith('/collections/') ? 'collection' : '';
      if (!destinationType) return;
      publish('lion_video_product_click', {
        destination_type: destinationType,
        destination_url: destination.origin + destination.pathname,
        video_handle: videoMatch[1],
        link_text: (link.textContent || '').trim().slice(0, 100)
      });
      return;
    }
    if (!/^\/blogs\/[^/]+\/[^/]+\/?$/.test(path)) return;
    if (destination.origin !== window.location.origin) return;
    const destinationType = destination.pathname.includes('/products/') ? 'product' : destination.pathname.startsWith('/collections/') ? 'collection' : '';
    if (!destinationType) return;
    publish('lion_blog_product_click', {
      destination_type: destinationType,
      destination_url: destination.origin + destination.pathname,
      link_text: (link.textContent || '').trim().slice(0, 100)
    });
  }, true);

  let videoViewPublished = false;
  function publishVideoView() {
    if (videoViewPublished) return;
    const match = /^\/pages\/(video-[a-z0-9-]+)\/?$/.exec(window.location.pathname);
    if (!match || !document.querySelector('.llv134-player')) return;
    videoViewPublished = publish('lion_video_guide_view', {
      video_handle: match[1],
      destination_type: 'video'
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', publishVideoView, { once: true });
  else publishVideoView();
  window.addEventListener('load', publishVideoView, { once: true });

  function checkReading() {
    framePending = false;
    if (document.visibilityState !== 'visible' || !/^\/blogs\/[^/]+\/[^/]+\/?$/.test(window.location.pathname)) return;
    document.querySelectorAll('[data-article-content]').forEach(function (content) {
      if (readArticles.has(content)) return;
      const bounds = content.getBoundingClientRect();
      if (bounds.height <= 0 || bounds.top >= window.innerHeight) return;
      const progress = Math.min(100, Math.max(0, (window.innerHeight - bounds.top) / bounds.height * 100));
      if (progress >= 75 && publish('lion_blog_scroll_75', { percent_scrolled: 75, destination_type: 'article' })) readArticles.add(content);
    });
  }
  function scheduleReading() {
    if (framePending) return;
    framePending = true;
    window.requestAnimationFrame(checkReading);
  }
  window.addEventListener('scroll', scheduleReading, { passive: true });
  window.addEventListener('resize', scheduleReading, { passive: true });
  document.addEventListener('visibilitychange', scheduleReading);
  document.addEventListener('shopify:section:load', scheduleReading);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleReading, { once: true });
  else scheduleReading();
}());
